<template>
  <ul class="links">
    <li
      v-for="(link, index) in links"
      :key="index"
      class="links__item">
      <button-link-of-admin-tool-bar
        v-bind="link"
        class="button"/>
    </li>
  </ul>
</template>

<script>
import { adminToolBarLinks } from '@/mikan/_shared/types/vueTypes/adminToolBarLink';
import ButtonLinkOfAdminToolBar from '@/mikan/pc/components/molecules/ButtonLinkOfAdminToolBar.vue';

export default {
  components: {
    ButtonLinkOfAdminToolBar,
  },
  props: {
    links: adminToolBarLinks.def(() => []),
  },
};
</script>

<style lang="scss" scoped>
@import '~@/mikan/pc/base/constants';

.links {
  $horizontal-gutter: 12px;
  $vertical-gutter: 8px;

  display: flex;
  margin-right: -$horizontal-gutter;
  margin-bottom: -4px;

  &__item {
    font-size: $size-l;
    font-weight: bold;

    &:nth-child(n + 2) {
      margin-left: 30px - $horizontal-gutter * 2;
    }
  }

  &__icon {
    font-size: 10px;
  }
}

.button {
  padding: 6px 25px;
  border-radius: 6px 6px 0 0;
}
</style>
